import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

import SolutionSidebar from '../elements/services/solution-sidebar';

import Banner1 from '../../images/electricpower2.jpg';
import ServicesPic1 from '../../images/services/service_91.png';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionMechanicalElectrical extends Component {

    render() {
        return (
            <>
                <Header1 />

                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{ backgroundImage: "url(" + Banner1 + ")" }}>
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">Mechanical, Electrical & Cryogenic Maintenance</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Mechanical & Electrical Maintenance</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2">
                            <div className="container about-video">

                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                         <SolutionSidebar activeService={9} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Mechanical, Electrical & Cryogenic Maintenance</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>
                                            We provide specialized maintenance services for mechanical systems, 
                                            electrical networks, and cryogenic installations to ensure safe and 
                                            continuous operation of industrial facilities.
                                        </p>

                                        <div className="row m-b30">
                                            <div className="col-md-12">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt="" />
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>
                                            Tailored support packages provide troubleshooting, inspection, maintenance, 
                                            and calibration for a wide range of equipment and systems.
                                        </p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Rotating equipment maintenance</li>
                                                    <li>Electrical & power systems service</li>
                                                    <li>Cryogenic system repair</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>HVAC services</li>
                                                    <li>Instrumentation & SCADA support</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Benefits</h4>
                                        <p>Optimized operations with minimized downtime and reliable performance.</p>

                                        <div className="row">
                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Improved equipment reliability</li>
                                                    <li><i className="flaticon-light-bolt"></i>Skilled multi-disciplinary teams</li>
                                                    <li><i className="flaticon-mask"></i>Compliance with QA/QC standards</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">Mechanical Services</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        Pumps, compressors, turbines, valves, and rotating machinery maintenance.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Electrical Services</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        Power distribution, control panels, substations, and electrical diagnostics.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="2">
                                                    <Link to="#">Cryogenic Systems</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="2">
                                                    <Card.Body>
                                                        Specialized maintenance for LNG, liquid nitrogen, and low-temperature systems.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                        </Accordion>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                <Footer1 />

            </>
        );
    }
}

export default SolutionMechanicalElectrical;
